import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { UtilsService } from 'src/app/core/services/utils.service';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';
import * as _ from 'lodash';
import { CurrentUserInfo } from 'src/app/core/models/currentUserInfo';
import { DashboardsService } from 'src/app/pages/dashboards/services/dashboards.service';
import { DashboardConfig, DashboardPosition } from 'src/app/pages/dashboards/models/dashboard-models';
import { saveDashboardConfig } from 'src/app/core/store/actions';
import { select, Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';
import { getApplySelectedCustomer, getCompleteState, getDashboards } from 'src/app/core/store/selectors';
import { ConfigurationsService } from 'src/app/core/services/configurations.service';
import { MenuItem } from 'src/app/core/models/menuItem';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, OnChanges, OnDestroy {
  @Input() displayNav: boolean = true;
  @ViewChild('sidenav') sideNav: any;
  open = true;
  stylesheetString = 'aft';
  menuList: any;

  basicDashboardChildMenu: any;
  selectedCustomer: string = '';
  dashboards$: Subscription;
  filters$: any;
  updateMenu$: any;

  isUpdatingMenuList = false;

  constructor(
    private dataService: DataService,
    private utilsService: UtilsService,
    private translate: TranslateService,
    private _store: Store<AppStateInterface>,
    private _dashboardService: DashboardsService,
    private _configurationsService: ConfigurationsService
  ) {

  }

  ngOnDestroy(): void {
    this.filters$.unsubscribe();
    this.updateMenu$.unsubscribe();
  }

  currentUserInfo: CurrentUserInfo;

  ngOnChanges() {
    if (this.sideNav) {
      this.toggleNav();
    }
  }

  ngOnInit() {
    this.updateMenu$ = this._dashboardService.updateDashboardsMenu$.subscribe((event) => {
      this.updateMenuListOnDashboardChange(event);
    });
    this._configurationsService.onChangeMenuOrder.subscribe((newOrderMenuList) => {
      this.menuList = this.addReportsChildren([...newOrderMenuList]);
    });
    this.stylesheetString = this.utilsService.getStylesheetString();
    this.currentUserInfo = this.dataService.getCurrentUserInfo();
    this.setMenuList();

    // let menu = JSON.parse(JSON.stringify(this.menuList));
    // this.menuList = [];
    // menu.push({ label: 'TrackingMapMisc', w: true, child: Array(0), order: 99 });
    // this.menuList = menu;

    this.filters$ = this._store.pipe(
      select(getApplySelectedCustomer),
    ).subscribe((customer) => {
      if (customer.uid && this.selectedCustomer !== customer.uid) {
        this.selectedCustomer = customer.uid;
        this.getMenuInfo();
      }
    });
  }

  toggleNav() {
    this.sideNav.toggle();
  }

  getMenuInfo() {
    if (!this.currentUserInfo || !this.currentUserInfo.menu) {
      console.warn('currentUserInfo or menu not initialized');
      return;
    }

    this._configurationsService.checkDashboardGrant(this.selectedCustomer)?.subscribe((res: any) => {
      this.currentUserInfo = res.user;
      this.setMenuList();
    });
  }

  setMenuList() {
    this._configurationsService.getUserMenuConfigFromAPI().subscribe((menu) => {
      this.menuList = this.addReportsChildren([...menu]);
    });
  }

  /**
   * La voce "reports" arriva dal BE senza figli: aggiunge le sottovoci
   * "report" (gestione report), "scheduledReport" (schedulazione) e "generatedReport" (report generati salvati).
   * TODO: rimuovere quando il BE esporrà direttamente le sottovoci.
   */
  private addReportsChildren(menu: MenuItem[]): MenuItem[] {
    return menu.map((item) => {
      if (item.label !== 'reports') {
        return item;
      }
      const child: MenuItem[] = [...(item.child || [])];
      if (!child.some((c) => c.label === 'report')) {
        child.push({ label: 'report', w: true, child: [], order: 10, env: null });
      }
      if (!child.some((c) => c.label === 'scheduledReport')) {
        child.push({ label: 'scheduledReport', w: true, child: [], order: 20, env: null });
      }
      if (!child.some((c) => c.label === 'generatedReport')) {
        child.push({ label: 'generatedReport', w: true, child: [], order: 30, env: null });
      }
      return { ...item, child };
    });
  }

  /**
   *
   * @param event {dashboard: DashboardConfig, action: 'new' | 'edit' | 'delete'}
   * This method updates the menu list based on dashboard changes.
   * It listens to the dashboard service for changes and updates the menu accordingly.
   * It avoids api calls by using the current user info stored in the data service.
   */
  updateMenuListOnDashboardChange(event: { dashboard: DashboardConfig, action: 'new' | 'edit' | 'duplicate' | 'delete' }) {
    this.dashboards$ = this._store.pipe(select(getDashboards)).subscribe(dashboardsList => {
      if (this.isUpdatingMenuList)
        return;

      this.isUpdatingMenuList = true;
      const { dl, ui } = this._configurationsService.updateMenuListOnDashboardChange(event, dashboardsList);

      this._store.dispatch(saveDashboardConfig({ dashboards: dl }));

      setTimeout(() => {
        this.dashboards$.unsubscribe();
      }, 0);

      setTimeout(() => {
        this.dataService.setCurrentUserInfo(ui);

        this.setMenuList();
        this.isUpdatingMenuList = false;
      }, 1000);
    });
  }
}
